module.exports = __webpack_public_path__ + "static/media/beaufort.557849e0.jpg";